"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_1 = require("react");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var ImpersonatingBanner_1 = require("containers/Admin/CustomerManagement/ImpersonateTable/ImpersonatingBanner");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var dateTime_1 = require("utils/dateTime");
var hooks_1 = require("utils/hooks");
var TrialCheckout = function (_a) {
    var _b;
    var company = _a.company, profile = _a.profile;
    var _c = __read((0, hooks_1.useSubmitter)('companies', profile === null || profile === void 0 ? void 0 : profile.companyId), 1), companySubmitter = _c[0];
    var expirationDay = (_b = company === null || company === void 0 ? void 0 : company.freeTrialFinishDate) === null || _b === void 0 ? void 0 : _b.toDate();
    var daysLeft = (0, dateTime_1.daysUntil)(expirationDay);
    // ToDo handle this only in BE
    (0, react_1.useEffect)(function () {
        if (daysLeft > 0) {
            return;
        }
        companySubmitter({ plan: 'Start-Up', planStatus: 'active' });
    }, [daysLeft]);
    return ((0, jsx_runtime_1.jsxs)(ImpersonatingBanner_1.StyledBox, __assign({ display: "flex", justifyContent: "center", alignContent: "center", className: ImpersonatingBanner_1.classes.bannerWrapper }, { children: [(0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3 }, { children: ["Your free trial ends in ", (0, end2end_1.handlePlural)('day')(daysLeft), ". Add your billing information now to avoid losing access to Hudled"] })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ url: "/settings/billing/plan", sx: { mx: 3 } }, { children: "Choose plan" }))] })));
};
exports.default = TrialCheckout;
